import { render, staticRenderFns } from "./PTMappings.vue?vue&type=template&id=26c48607&scoped=true&"
import script from "./PTMappings.vue?vue&type=script&lang=js&"
export * from "./PTMappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c48607",
  null
  
)

export default component.exports